// extracted by mini-css-extract-plugin
export default {"PriceContainer":"Price_PriceContainer__KykMM","fall":"Price_fall__5KbNs","_NA":"Price__NA__ZtT3N","_AV":"Price__AV__178cv"};